import React, { RefObject } from "react";
import { Link } from "react-router-dom";
import OutsideClickHandler from "react-outside-click-handler";

import classes from "../AppHeader/style.scss";

interface PropsInterface {
	setClickedHeaderMenu: (value: string | null) => void;
	ignoreRef?: RefObject<HTMLDivElement>;
}

const SupportDropdownMenu: React.FC<PropsInterface> = ({
	setClickedHeaderMenu,
	ignoreRef
}) => {
	return (
		<OutsideClickHandler onOutsideClick={(e) => {
			if (ignoreRef?.current && ignoreRef.current.contains(e.target)) {
				return;
			}

			setClickedHeaderMenu(null);
		}}>
			<div className={classes.headerItemDropdown}>
				<div className={classes.headerItemDropdownContent}>
					<p className={classes.titleSection}>Support Centre</p>

					<Link
						className={classes.profileButton}
						to="/support/glossary"
						onClick={() => setClickedHeaderMenu(null)}
					>
						<p className={classes.option}>
							<i className="fa-sharp fa-regular fa-book-open fa-sm"/>

							<span>Glossary</span>
						</p>
					</Link>

					<Link
						className={classes.profileButton}
						to="/support/methodology"
						onClick={() => setClickedHeaderMenu(null)}
					>
						<p className={classes.option}>
							<i className="fa-sharp fa-regular fa-flask fa-sm"/>

							<span>Methodology</span>
						</p>
					</Link>
				</div>
			</div>
		</OutsideClickHandler>
	);
};

export default SupportDropdownMenu;
